<template>
  <div>
    <h1>Editar Area</h1>
    <b-card no-body class="border-0">
      <Form @saved="loadData" />
    </b-card>
  </div>
</template>

<script>
import Form from "../Components/Form.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: { Form },
  computed: {
    ...mapState("areas", ["area"]),
  },
  methods: {
    ...mapActions("areas", ["ActionNewArea", "ActionShow"]),
    async loadData(id) {
      try {
        await this.ActionShow(id);
      } catch (error) {
        this.$notifications.addNotification({
          message: error.data.responseMessage,
          icon: "exclamation-triangle",
          type: "danger",
        });

        this.$router.push({ name: "areas_list" });
      }
    },
  },
  async created() {
    this.ActionNewArea();
    await this.loadData(this.$route.params.id);
  },
};
</script>

<style></style>
